module.exports = __webpack_public_path__ + "img/banner-1-m.b6061561.jpg";